import {emptyObject, statusWet} from "../../util/util";
import {MIN_WET_LOGS_TO_DISPLAY, WET_LOGS_LIMITATION_NO} from "../../api/constants";
import moment from "moment/moment";

class LogController {
  
  cloneDeep(log) {
    return {...log}
  }
  
  _wetLogsExist(logs) {
    
    let exist = false,
        count = 0;
    
    if(logs && !emptyObject(logs)) {
      
      Object.keys(logs).map(id => {
        
        let log = logs[id];
        
        if(statusWet(log)) {
          exist = true;
          count++;
        }
        
        return exist;
      });
    }
    
    if(count < MIN_WET_LOGS_TO_DISPLAY) {
      exist = false;
    }
    
    return exist;
  }
  
  _setWetStatusLogs(logs) {
    
    let wetStatusLogs = {};
    
    if(logs && !emptyObject(logs)) {
      
      wetStatusLogs = Object.keys(logs)
        .filter(id => logs[id].drynessStatusId === 0)
        .reduce((wetLogs, id) => {
          wetLogs[id] = logs[id];
          return wetLogs;
        }, {});
    }
    
    return wetStatusLogs;
  }
  
  _countWetStatusLogs(logs) {
    
    let wetLogs = this._setWetStatusLogs(logs);
    return Object.keys(wetLogs).length;
  }
  
  _setLogsInitialValuesByHour() {
    let values = [];
    for (let h = 0; h < 24; h++) {
      values.push(0);
    }
    return values;
  }
  
  _setWetLogsHoursArray(logs) {
    
    let wetLogs = this._setWetStatusLogs(logs);
    
    let hours = [];
    if(wetLogs && !emptyObject(wetLogs)) {
      
      Object.keys(wetLogs).map(id => {
        hours.push(wetLogs[id].hour);
        return hours;
      });
    }
    
    if(WET_LOGS_LIMITATION_NO) {
      hours = hours.slice(-WET_LOGS_LIMITATION_NO);
    }
    
    return hours;
  }
  
  // creates object with hours as keys and count of repeating hours as value (obj[hour] = count)
  _countWetLogsRepeatingHours(logs) {
    
    let hours = this._setWetLogsHoursArray(logs);
    
    let hoursCopy = hours.slice(0); // hours array copy for comparison of same values
    
    let hoursCount = [];
    for (let i = 0; i < hours.length; i++) {
      
      let count = 0;
      for (let c = 0; c < hoursCopy.length; c++) {
        
        if (hours[i] === hoursCopy[c]) {
          count++;
          delete hoursCopy[c];
        }
      }
      
      if (count > 0) {
        let h = {};
        h.hour = hours[i];
        h.count = count;
        hoursCount.push(h);
      }
    }
    
    return hoursCount;
  }
  
  _setWetLogsRepeatingOccurrencesByHour(logs) {
    
    let logsByHour = this._setLogsInitialValuesByHour();
    let wetLogsHoursCount = this._countWetLogsRepeatingHours(logs);
    
    Object.keys(wetLogsHoursCount).map(key => {
      let hour = wetLogsHoursCount[key].hour;
      let count = wetLogsHoursCount[key].count;
      logsByHour[hour] = count;
      return logsByHour;
    });
    
    return logsByHour;
  }
  
  _setWetLogsTimes(logs) {
    
    let wetLogs = this._setWetStatusLogs(logs);
    
    let times = [];
    if(wetLogs && !emptyObject(wetLogs)) {
      
      Object.keys(wetLogs).map(id => {
        let time = moment(wetLogs[id].time).format("DD/MM, HH:mm:ss");
        times.push(time);
        return times;
      });
    }
    
    if(WET_LOGS_LIMITATION_NO) {
      times = times.slice(-WET_LOGS_LIMITATION_NO);
    }
    
    return times;
  }
  
}
export default new LogController();


// WEBPACK FOOTER //
// ./src/models/logs/logController.js